import { DocumentGroup } from 'types/documentGroup';

export enum GroupsActionTypes {
  UPDATE_GROUPOUTPUTS = '@@settings/UPDATE_GROUPOUTPUTS',
}

export interface GroupsState {
  documentGroups: DocumentGroup[];
}
